import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";

import { Globe, X } from "lucide-react";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Link } from "react-router-dom";
import { appStoreLogo, playStoreLogo } from "assets";
import { useAppSelector } from "store/store";
import { useDispatch } from "react-redux";
import { setIsDailogDetailTools } from "store/toolStore";

interface DialogProps {}
export default function DailogDetailTools({}: DialogProps) {
  const { isDetailTools, isDailogDetailTools } = useAppSelector((state) => state.tool);
  const diapatch = useDispatch();

  return (
    <>
      <Dialog open={isDailogDetailTools}>
        <DialogContent isShowBtnXClose={false} className="max-w-full lg:max-w-[1000px] md:max-w-[800px] h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <DialogHeader>
            <DialogTitle> {isDetailTools?.title}</DialogTitle>
            <DialogDescription>{isDetailTools?.type}</DialogDescription>
            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => diapatch(setIsDailogDetailTools(false))}
            >
              <X />
            </div>
          </DialogHeader>

          <div className="flex flex-1 h-full flex-col space-y-2 ">
            <div className="w-full ">
              <div className="relative z-1 w-full">
                <div className=" relative overflow-hidden h-[300px] flex items-center ">
                  <ImageUrl className="rounded-t-md object-cover w-[300px] h-full" src={isDetailTools?.image_url} alt="" />
                  <div className=" ms-[50px]">
                    <span className="text-md font-semibold ">Learn more...</span>
                    <div className="flex items-center gap-2 h-[20px] mt-4">
                      {isDetailTools?.ios_url && (
                        <Link to={isDetailTools?.ios_url} target="_blank" rel="noopener noreferrer" className="flex flex-col item-center">
                          <img src={appStoreLogo} className="h-[40px] w-[40px]" alt="logo" />
                        </Link>
                      )}
                      {isDetailTools?.android_url && (
                        <Link to={isDetailTools?.android_url} target="_blank" rel="noopener noreferrer">
                          <img src={playStoreLogo} className="h-[30px] w-[30px]" alt="logo" />
                        </Link>
                      )}
                      {isDetailTools?.web_url && (
                        <Link to={isDetailTools?.web_url} target="_blank" rel="noopener noreferrer">
                          <Globe className="w-[30px] h-[30px] text-blue-500" />
                        </Link>
                      )}
                      {isDetailTools?.window_url && (
                        <Link to={isDetailTools?.window_url} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands text-[30px] fa-windows text-blue-500"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-4 flex flex-col gap-3">
                  <span
                    className="text-sm  overflow-hidden"
                    dangerouslySetInnerHTML={{
                      __html: isDetailTools?.sub_title?.replace(/\n/g, "<br />"),
                    }}
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
